import { Pipe, PipeTransform } from '@angular/core';
import { Utility } from '../../core/utils';

@Pipe({name: 'nFormatter'})
export class NFormatterPipe implements PipeTransform {
    /**
     * Transform
     *
     * @param {string} value
     * @param {any[]} args
     * @returns {string}
     */
    transform(value: any): string {
        return value ? Utility.nFormatter(value) : value;
    }
}
